import { render, staticRenderFns } from "./MediaGroupMediaNew.vue?vue&type=template&id=6040c5b7&"
import script from "./MediaGroupMediaNew.vue?vue&type=script&lang=js&"
export * from "./MediaGroupMediaNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports